import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import ThreatModelerConfigListing from "./ThreatModelerConfigListing";
import ThreatModelerCredentialsForm from "./ThreatModelerCredentialsForm";

export default function ThreatModelerPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={ThreatModelerCredentialsForm}
      PullConfigListingView={ThreatModelerConfigListing}
    />
  );
}